import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TrackAndTrace from '@/modules/track-and-trace/track-and-trace.component';

const TrackAndTracePage = () => <TrackAndTrace />;

TrackAndTracePage.getLayout = (page) => page;
TrackAndTracePage.title = 'Enterprise';

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default TrackAndTracePage;
